/* Responsive video in post content */
(function () {
  const sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
    ".gh-content object",
    ".gh-content embed",
  ];
  reframe(document.querySelectorAll(sources.join(",")));
})();

(function () {
  if (
    !document.body.classList.contains("home-template") &&
    !document.body.classList.contains("post-template")
  ) {
    pagination();
  }
})();

/* Wrap "Highlights" section in a .highlight div (must run before TOC) */
(function () {
  const highlightsHeader = Array.from(
    document.querySelectorAll(".gh-article-content p"),
  ).find((p) => p.textContent.trim() === "Highlights");

  if (highlightsHeader) {
    const highlightsList = highlightsHeader.nextElementSibling;

    if (highlightsList && highlightsList.tagName === "UL") {
      const wrapper = document.createElement("div");
      wrapper.classList.add("highlight");
      highlightsHeader.parentNode.insertBefore(wrapper, highlightsHeader);
      wrapper.appendChild(highlightsHeader);
      wrapper.appendChild(highlightsList);
    }
  }
})();

/* Reading progress + summary list */
(function () {
  const article = document.querySelector(".gh-article");
  const main = document.querySelector(".gh-main");
  if (!article) return;

  const content = article.querySelector(".gh-content");
  const tocList = article.querySelector(".gh-article-summary-list");
  const progressBar = document.querySelector(".gh-reading-progress-bar");
  const header = article.querySelector(".gh-article-header");
  if (!content || !tocList || !header) return;

  const articleContent = article.querySelector(".gh-article-content");
  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");

  const headings = Array.from(content.querySelectorAll("h2"));
  const sections = [];
  const existingIds = new Set(
    headings.map((heading) => heading.getAttribute("id")).filter(Boolean),
  );

  const ensureUniqueId = (baseId) => {
    let id = baseId || "section";
    let i = 1;
    while (existingIds.has(id)) {
      id = `${baseId}-${i}`;
      i += 1;
    }
    existingIds.add(id);
    return id;
  };

  const highlightEl =
    articleContent && articleContent.querySelector(".highlight");

  if (highlightEl) {
    const highlightId = ensureUniqueId("highlights");
    highlightEl.setAttribute("id", highlightId);
    sections.push({
      id: highlightId,
      label: "Highlights",
      element: highlightEl,
    });

    let sibling = highlightEl.nextElementSibling;
    if (sibling && !/^H[1-6]$/.test(sibling.tagName)) {
      const introId = ensureUniqueId("introduction");
      sibling.setAttribute("id", introId);
      sections.push({ id: introId, label: "Introduction", element: sibling });
    }
  } else if (
    content.firstElementChild &&
    !/H2|H3/.test(content.firstElementChild.tagName)
  ) {
    const introId = ensureUniqueId("introduction");
    sections.push({ id: introId, label: "Introduction", element: content });
  }

  headings.forEach((heading) => {
    const label = heading.textContent.trim();
    const id = ensureUniqueId(heading.getAttribute("id") || slugify(label));
    heading.setAttribute("id", id);
    sections.push({ id, label, element: heading });
  });

  tocList.innerHTML = "";
  const linkEls = [];
  const tocAside = article.querySelector(".gh-article-summary");

  if (!sections.length) {
    if (tocAside) {
      tocAside.hidden = true;
    }
  } else {
    sections.forEach((section) => {
      const item = document.createElement("li");
      const link = document.createElement("a");
      link.className = "gh-article-summary-link";
      link.href = `#${section.id}`;
      link.textContent = section.label || "Section";
      item.appendChild(link);
      tocList.appendChild(item);
      linkEls.push(link);
    });
  }

  const state = {
    sectionTops: [],
    headerBottom: 0,
    articleBottom: 0,
  };

  const recalc = () => {
    state.sectionTops = sections.map((section) =>
      Math.floor(section.element.getBoundingClientRect().top + window.scrollY),
    );
    state.headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
    state.articleBottom =
      article.getBoundingClientRect().bottom + window.scrollY;
  };

  const update = () => {
    const scrollY = window.scrollY;
    const triggerY = scrollY + Math.min(window.innerHeight * 0.35, 240);

    if (progressBar) {
      const start = article.getBoundingClientRect().top + window.scrollY;
      const end = state.articleBottom - window.innerHeight * 0.45;
      const raw = (scrollY - start) / Math.max(1, end - start);
      const progress = Math.min(1, Math.max(0, raw));
      progressBar.style.width = `${progress * 100}%`;
      progressBar.parentElement?.classList.toggle(
        "is-visible",
        scrollY > start,
      );
    }

    let activeIndex = 0;
    for (let i = 0; i < state.sectionTops.length; i += 1) {
      if (triggerY >= state.sectionTops[i]) {
        activeIndex = i;
      }
    }

    linkEls.forEach((link, idx) => {
      link.classList.toggle("is-active", idx === activeIndex);
    });
  };

  recalc();
  update();

  window.addEventListener("scroll", () => requestAnimationFrame(update), {
    passive: true,
  });
  window.addEventListener("resize", () => {
    recalc();
    update();
  });
})();

/* Responsive HTML table */
(function () {
  const tables = document.querySelectorAll(
    ".gh-content > table:not(.gist table)",
  );

  tables.forEach(function (table) {
    const wrapper = document.createElement("div");
    wrapper.className = "gh-table";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();

var headerEl = document.querySelector("header.gh-main-header");
var headerTop = headerEl ? headerEl.offsetTop + 184 : 0;
var lastScrollY = window.pageYOffset;

if (headerEl) {
  window.onscroll = function () {
    innerScroll();
  };
}

function innerScroll() {
  var header = document.querySelector("header.gh-main-header");
  if (header) {
    var currentScroll = window.pageYOffset;
    if (currentScroll > headerTop) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }

    if (window.innerWidth < 992) {
      header.classList.remove("header--hidden");
      lastScrollY = currentScroll;
      return;
    }

    if (currentScroll !== lastScrollY) {
      document
        .querySelectorAll("header .nav-dropdown.is-open")
        .forEach(function (dropdown) {
          dropdown.classList.remove("is-open");
          dropdown.classList.remove("active");
          var dropdownTrigger = dropdown.querySelector(".nav-link");
          if (dropdownTrigger) {
            dropdownTrigger.setAttribute("aria-expanded", "false");
          }
        });
    }

    if (currentScroll <= headerTop) {
      header.classList.remove("header--hidden");
    } else if (currentScroll > lastScrollY) {
      if (
        !document.body.classList.contains("post-template") &&
        !document.body.classList.contains("index-template")
      ) {
        header.classList.add("header--hidden");
      }
    } else if (currentScroll < lastScrollY - 5) {
      header.classList.remove("header--hidden");
    }
    lastScrollY = currentScroll;
  }
}

document.addEventListener("mousemove", function (event) {
  if (event.clientY > 40) return;
  var header = document.querySelector("header.gh-main-header");
  if (header && header.classList.contains("header--hidden")) {
    header.classList.remove("header--hidden");
  }
});

if (!document.querySelector("[data-nav]")) {
document.querySelectorAll("header .nav-dropdown").forEach(function (dropdown) {
  const trigger = dropdown.querySelector(".nav-link");
  const menu = dropdown.querySelector(".nav-dropdown__menu");
  let closeTimer = null;

  const setDropdownOpen = function (isOpen) {
    dropdown.classList.toggle("is-open", isOpen);
    if (trigger) {
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
  };

  const closeOtherDropdowns = function () {
    document
      .querySelectorAll("header .nav-dropdown.is-open")
      .forEach(function (other) {
        if (other !== dropdown) {
          other.classList.remove("is-open");
          other.classList.remove("active");
          const otherTrigger = other.querySelector(".nav-link");
          if (otherTrigger) {
            otherTrigger.setAttribute("aria-expanded", "false");
          }
        }
      });
  };

  if (trigger) {
    trigger.addEventListener("click", function (event) {
      if (window.innerWidth >= 992) {
        event.preventDefault();
      }
      closeOtherDropdowns();
      setDropdownOpen(!dropdown.classList.contains("is-open"));
    });
  }

  function clearCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    clearCloseTimer();
    closeTimer = setTimeout(function () {
      if (!dropdown.matches(":hover")) {
        setDropdownOpen(false);
        dropdown.classList.remove("active");
      }
    }, 120);
  }

  dropdown.addEventListener("mouseenter", function () {
    if (window.innerWidth < 992) return;
    clearCloseTimer();
    closeOtherDropdowns();
    setDropdownOpen(true);
  });

  dropdown.addEventListener("mouseleave", function () {
    if (window.innerWidth < 992) return;
    scheduleClose();
  });

  if (menu) {
    menu.addEventListener("mouseenter", function () {
      if (window.innerWidth < 992) return;
      clearCloseTimer();
      setDropdownOpen(true);
    });

    menu.addEventListener("mouseleave", function () {
      if (window.innerWidth < 992) return;
      scheduleClose();
    });
  }
});

document.addEventListener("click", function (e) {
  var toggle = e.target.closest("header .hamburger-icon");
  if (!toggle) return;
  var isExpanded = toggle.getAttribute("aria-expanded") === "true";
  toggle.setAttribute("aria-expanded", (!isExpanded).toString());
  toggle.classList.toggle("active");
  var nav = document.querySelector("header nav");
  if (nav) nav.classList.toggle("active");
  document.body.classList.toggle("menu-open");
});

document.addEventListener("click", function (event) {
  const link = event.target.closest("header .nav-dropdown__menu a");
  if (!link) return;

  document
    .querySelectorAll("header .nav-dropdown__menu a.active")
    .forEach(function (item) {
      item.classList.remove("active");
    });
  document
    .querySelectorAll("header .nav-dropdown.active")
    .forEach(function (item) {
      item.classList.remove("active");
    });

  link.classList.add("active");
  const parentDropdown = link.closest(".nav-dropdown");
  if (parentDropdown) {
    parentDropdown.classList.add("active");
  }
});
}

/* Blog feed filters */
(function () {
  const buildDynamicFilterButtons = ({
    filterSelector,
    cardSelector,
    tagSelector,
    excludeSlugs = [],
  }) => {
    const filter = document.querySelector(filterSelector);
    if (!filter) return;

    const exclude = new Set(excludeSlugs);
    const tagMap = new Map();

    document.querySelectorAll(cardSelector).forEach(function (card) {
      card.querySelectorAll(tagSelector).forEach(function (tagEl) {
        const slug = tagEl.dataset.slug;
        if (!slug || exclude.has(slug) || tagMap.has(slug)) return;

        tagMap.set(slug, {
          name: tagEl.textContent.trim(),
          icon: tagEl.dataset.icon || "",
        });
      });
    });

    Array.from(filter.querySelectorAll("button"))
      .slice(1)
      .forEach(function (button) {
        button.remove();
      });

    Array.from(tagMap.entries())
      .sort(function (a, b) {
        return a[1].name.localeCompare(b[1].name);
      })
      .forEach(function (entry) {
        const slug = entry[0];
        const tag = entry[1];
        const button = document.createElement("button");
        button.type = "button";
        button.dataset.slug = slug;
        button.textContent = tag.name;

        if (tag.icon) {
          button.classList.add("has-icon");
          button.style.setProperty("--tag-icon", "url(" + tag.icon + ")");
        }

        filter.appendChild(button);
      });
  };

  const initFeedFilter = ({
    filterSelector,
    cardSelector,
    emptySelector,
    searchSelector,
    titleSelector,
  }) => {
    const filter = document.querySelector(filterSelector);
    if (!filter) return;

    const buttons = Array.from(filter.querySelectorAll("button"));
    const cards = Array.from(document.querySelectorAll(cardSelector));
    if (!buttons.length || !cards.length) return;

    const emptyState = document.querySelector(emptySelector);
    const searchInput = document.querySelector(searchSelector);

    const setActive = (target) => {
      buttons.forEach((button) => {
        button.classList.toggle("active", button === target);
      });
    };

    const getCardText = (card) => {
      if (card.dataset.searchText) return card.dataset.searchText;
      const title =
        card.querySelector(titleSelector)?.textContent?.trim() || "";
      const tags = (card.dataset.tags || "").replace(/,/g, " ");
      const text = `${title} ${tags}`.toLowerCase();
      card.dataset.searchText = text;
      return text;
    };

    const matchesTag = (card, slug) => {
      const tags = (card.dataset.tags || "")
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);

      return tags.includes(slug);
    };

    const state = {
      slug: null,
      query: "",
    };

    const applyFilters = () => {
      const query = state.query.trim().toLowerCase();
      let visibleCount = 0;
      cards.forEach((card) => {
        const matchesQuery = !query || getCardText(card).includes(query);
        const matchesCategory = !state.slug || matchesTag(card, state.slug);
        const isVisible = matchesQuery && matchesCategory;

        card.style.display = isVisible ? "" : "none";

        if (isVisible) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }
    };

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const slug = button.dataset.slug;
        const beforeTop = filter.getBoundingClientRect().top;
        setActive(button);
        state.slug = slug || null;
        applyFilters();
        const afterTop = filter.getBoundingClientRect().top;
        const delta = afterTop - beforeTop;
        if (delta) {
          window.scrollBy({ top: delta, left: 0, behavior: "auto" });
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", () => {
        state.query = searchInput.value || "";
        const allButton =
          buttons.find((button) => !button.dataset.slug) || buttons[0];
        state.slug = null;
        setActive(allButton);
        applyFilters();
      });
    }

    applyFilters();
  };

  buildDynamicFilterButtons({
    filterSelector: ".blog-filters .filter",
    cardSelector: ".gh-feed.normal-feed .gh-card",
    tagSelector: ".gh-card-tag[data-slug]",
  });

  initFeedFilter({
    filterSelector: ".blog-filters .filter",
    cardSelector: ".gh-feed.normal-feed .gh-card",
    emptySelector: ".gh-feed.normal-feed .gh-feed-empty",
    searchSelector: "#search",
    titleSelector: ".gh-card-title",
  });
})();

/* Progressive card images: compressed placeholder, lazy high-quality upgrade */
(function () {
  var images = document.querySelectorAll(".gh-card-image__img[data-hq-srcset]");
  if (!images.length) {
    return;
  }

  function upgradeImage(img) {
    if (img.dataset.hqLoaded === "true") {
      return;
    }
    img.dataset.hqLoaded = "true";

    var hqSrcset = img.getAttribute("data-hq-srcset");
    var hqSizes = img.getAttribute("data-hq-sizes");
    var hqSrc = img.getAttribute("data-hq-src");
    if (!hqSrcset) {
      return;
    }

    var loader = new Image();
    if (hqSizes) {
      loader.sizes = hqSizes;
    }
    loader.srcset = hqSrcset;
    if (hqSrc) {
      loader.src = hqSrc;
    }

    function applyHighQuality() {
      if (hqSizes) {
        img.sizes = hqSizes;
      }
      img.srcset = hqSrcset;
      if (hqSrc) {
        img.src = hqSrc;
      }
      img.classList.add("is-hq-loaded");
      img.removeAttribute("data-hq-srcset");
      img.removeAttribute("data-hq-sizes");
      img.removeAttribute("data-hq-src");
    }

    if (loader.complete) {
      applyHighQuality();
      return;
    }

    loader.onload = applyHighQuality;
    loader.onerror = function () {
      img.classList.add("is-hq-loaded");
    };
  }

  var eagerImages = [];
  var lazyImages = [];

  images.forEach(function (img) {
    if (img.classList.contains("gh-card-image__img--eager-hq")) {
      eagerImages.push(img);
    } else {
      lazyImages.push(img);
    }
  });

  eagerImages.forEach(upgradeImage);

  if (!lazyImages.length) {
    return;
  }

  if (!("IntersectionObserver" in window)) {
    lazyImages.forEach(upgradeImage);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }
        upgradeImage(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "300px 0px", threshold: 0.01 },
  );

  lazyImages.forEach(function (img) {
    observer.observe(img);
  });
})();

/* Page loaded class */
(function () {
  const addLoadedClass = () => {
    document.body.classList.add("is-loaded");
  };
  if (document.readyState === "complete") {
    addLoadedClass();
    return;
  }
  window.addEventListener("load", addLoadedClass, { once: true });
})();

/* Post card: overlapping avatars + "Jinu & Keny" first-name labels */
(function () {
  function capitalizeFirstWord(word) {
    if (!word) {
      return "";
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  function formatCardAuthorFirstNames(container) {
    var els = container.querySelectorAll("[data-author-name]");
    if (!els.length) {
      return "";
    }
    var names = Array.prototype.map
      .call(els, function (el) {
        var full = (
          el.getAttribute("data-author-name") ||
          el.textContent ||
          ""
        ).trim();
        var first = full.split(/\s+/)[0];
        return first ? capitalizeFirstWord(first) : "";
      })
      .filter(Boolean);
    if (!names.length) {
      return "";
    }
    if (names.length === 1) {
      return names[0];
    }
    if (names.length === 2) {
      return names[0] + " & " + names[1];
    }
    var last = names.pop();
    return names.join(", ") + " & " + last;
  }

  function initCardAuthorNames(root) {
    root = root || document;
    var spans = root.querySelectorAll(".gh-card-author-names");
    Array.prototype.forEach.call(spans, function (span) {
      var links = span.querySelectorAll("a[data-author-name]");
      if (links.length) {
        Array.prototype.forEach.call(links, function (anchor) {
          var full = (
            anchor.getAttribute("data-author-name") ||
            anchor.textContent ||
            ""
          ).trim();
          var first = full.split(/\s+/)[0];
          if (first) {
            anchor.textContent = capitalizeFirstWord(first);
          }
        });
        var seps = span.querySelectorAll(".gh-card-author-sep");
        if (links.length === 2 && seps.length === 1) {
          seps[0].textContent = " & ";
        }
        return;
      }
      var label = formatCardAuthorFirstNames(span);
      if (!label) {
        return;
      }
      while (span.firstChild) {
        span.removeChild(span.firstChild);
      }
      span.appendChild(document.createTextNode(label));
    });
  }

  window.netraInitCardAuthorNames = initCardAuthorNames;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initCardAuthorNames(document);
    });
  } else {
    initCardAuthorNames(document);
  }
})();

/* Copy Link Functionality */
(function () {
  document.querySelectorAll(".js-copy-link").forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var url = this.getAttribute("data-url");
      if (!url) return;

      navigator.clipboard.writeText(url).then(function () {
        button.classList.add("is-copied");
        var tooltip = button.querySelector(".copy-tooltip");
        if (tooltip) {
          tooltip.textContent = "Copied!";
        }
        setTimeout(function () {
          button.classList.remove("is-copied");
        }, 2000);
      });
    });
  });
})();
